import styled from '@emotion/styled'
import { useDashMessage } from '../../../intl/intl.hooks'
import { SegmentSwitch } from '@retailer-platform/shared-components/src/tds'

const Container = styled.div`
  position: relative;
  font-size: 15px;
  font-weight: 600;
  margin-left: 10px;
`

interface Props {
  isWeeklyView: boolean
  handleDailyWeeklyToggle: (isWeeklyView: boolean) => void
}

export const DailyWeeklyToggle = (props: Props) => {
  const { isWeeklyView, handleDailyWeeklyToggle } = props
  const dayViewTypeMessage = useDashMessage('shiftsDomain.day')
  const weekViewTypeMessage = useDashMessage('shiftsDomain.week')
  const handleToggleSwitch = (value: string) => {
    handleDailyWeeklyToggle(value == 'true')
  }
  return (
    <Container>
      <SegmentSwitch
        onChange={handleToggleSwitch}
        value={isWeeklyView ? 'true' : 'false'}
        items={[
          {
            label: dayViewTypeMessage,
            value: 'false',
          },
          {
            label: weekViewTypeMessage,
            value: 'true',
          },
        ]}
      />
    </Container>
  )
}
